<template>
  <section class="main">
    <div class="main__content">
      <promo/>
      <apps class="main__apps" label="iOS" :list="ios" type="ios" />
      <apps class="main__apps" label="Cydia" :list="cydia" type="cydia" />
      <apps class="main__apps" label="macOS (AppStore)" :list="osx" type="osx" />
      <apps class="main__apps" label="macOS (Standalone)" :list="standalone" type="standalone" />
      <apps
        class="main__apps"
        :label-icon="require('@/assets/icon-apple-white.svg')"
        label="tv"
        :list="tvos"
        type="tvos"
      />
      <apps
        class="main__apps"
        :label-icon="require('@/assets/icon-books.svg')"
        :heading="$t('BOOKS')"
        :list="books"
        type="books"
        :vertical="true"
      />
    </div>
    <sidebar class="main__sidebar" />
  </section>
</template>

<script>
import Promo from '@/components/Promo';
import Apps from '@/components/Apps';
import Sidebar from '@/components/HomeSidebar';

export default {
  components: { Promo, Apps, Sidebar },
  data() {
    return {
      ios: {
        new: [],
        top: [],
      },
      cydia: {
        new: [],
        top: [],
      },
      osx: {
        new: [],
        top: [],
      },
      standalone: {
        new: [],
        top: [],
      },
      tvos: {
        new: [],
        top: [],
      },
      books: {
        new: [],
        top: [],
      },
    };
  },
  computed: {
    title() {
      return this.$t('SITE_TITLE');
    },
  },
  serverPrefetch() {
    return Promise.allSettled(this.getApps());
  },
  created() {
    this.getApps();
  },
  methods: {
    getApps() {
      const promises = [];
      ['ios', 'cydia', 'osx', 'tvos', 'standalone', 'books'].forEach((type) => {
        ['new', 'top'].forEach(((tab) => {
          promises.push(
            this.$api.search({ type, order: tab === 'new' ? 'added' : 'clicks_day' }).then((data) => {
              this[type][tab] = data.slice(0, 24);
            }),
          );
        }));
      });
      return promises;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: flex;

  @include notebook {
    flex-direction: column-reverse;
  }

  &__content {
    width: 100%;
    max-width: 800px;

    @include notebook {
      max-width: 100%;
    }
  }

  &__sidebar {
    width: 370px;
    margin-left: auto;

    @include notebook {
      margin-left: 0;
      width: 100%;
    }
  }

  &__apps {
    &:not(:last-child) {
      margin-bottom: 40px;

      @include notebook {
        margin-bottom: 30px;
      }
    }
  }
}
</style>
